import React from 'react';

import { TileGridBlockData } from 'api/cms';
import Box from 'components/Box';
import { H3 } from 'components/Text';

import CardsBlock from './CardsBlock';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const TileGridBlock = ({
  data: { sections, imageSize },
  pageUrl,
  blockId,
}: {
  data: TileGridBlockData;
  pageUrl: string;
  blockId: string;
}) => (
  <>
    {sections.map((section, index) => (
      <Box mt={index > 0 && 48}>
        <H3>{section.name}</H3>
        <CardsBlock
          pageUrl={pageUrl}
          blockId={blockId}
          data={{
            imageSize,
            cards: section.tiles.map((tile) => ({
              image: tile.thumbnail,
              headline: tile.heading,
              subheadline: tile.subHeading,
              text: `${tile.description.slice(0, 120)}${
                tile.description.length > 120 ? '...' : ''
              }`,
            })),
          }}
        />
      </Box>
    ))}
  </>
);

// eslint-disable-next-line import/no-default-export
export default TileGridBlock;
